module.exports = __webpack_public_path__ + "img/logo-white.b4440c45.png";